export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/c5a22f76aa6e0dcfeb513ce3613a4bd7.png";